// services/mappers/door.js
export const setDoor = (el = {}) => ({  
  createdAt: el?.CreatedAt || null,
  deletedAt: el?.DeletedAt || null,
  id: el?.ID || null,
  updatedAt: el?.UpdatedAt || null,
  campus_id: el?.campus_id || null,
  device_id: el?.device_id || null,
  display_id: el?.display_id || null,
  ip: el?.ip || null,
  nest_id: el?.nest_id || null,
  status: el?.state || "CLOSE",
  port: el?.port || 0,
});
